const title = `Le Mas de mon Père – Vins d'auteur au cœur de la Malepère`;
const description = `Au pied des Pyrénées, Frédéric Palacios cultive avec passion un vignoble bio, révélant la richesse et la singularité du terroir de la Malepère. Découvrez des vins d’exception façonnés dans le respect de la nature.`;
const siteUrl = 'https://palacios-masdemonpere.com';

const SEO = {
  title,
  description,
  canonical: siteUrl,
  additionalMetaTags: [
    {
      name: 'keywords',
      content: 'wine, Wine Store, alcohol store, wine and beer shop, total wine, liquor store'
    },
    {
      name: 'author',
      content: `Le Mas de mon Père – Vins d'auteur au cœur de la Malepère`
    },
    {
      name: 'theme-color',
      content: '#000000'
    },
    {
      name: 'application-name',
      content: `Le Mas de mon Père – Vins d'auteur au cœur de la Malepère`
    },
    {
      name: 'apple-mobile-web-app-title',
      content: `Le Mas de mon Père – Vins d'auteur au cœur de la Malepère`
    },
    {
      name: 'format-detection',
      content: 'telephone=no'
    },
    {
      httpEquiv: 'X-UA-Compatible',
      content: 'IE=edge'
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale = 1.0, user-scalable = no'
    }
  ],
  openGraph: {
    type: 'website',
    locale: 'fr',
    url: siteUrl,
    title,
    description,
    images: [
      {
        url: 'https://d2iac5vn4bt8yk.cloudfront.net/67d0186ee2e807675f035302/mdmp-new.svg',
        alt: 'Open Graph Image',
      },
    ],
  },
  twitter: {
    cardType: 'summary_large_image',
    image: 'https://d2iac5vn4bt8yk.cloudfront.net/67d0186ee2e807675f035302/mdmp-new.svg'
  }
};

export default SEO;
